'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.SKARTOVAN = exports.STORNOVAN = exports.PREDAN_DO_ARCHIVU_NEBO_SKARTOVAN = exports.PREDAN_DO_SPISOVNY = exports.UZAVREN = exports.VYRIZEN = exports.NEVYRIZEN = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T17:38:54Z                      #

// ##############################################################

/**
 * Určuje stav, v jakém se spis momentálně nachází.
 */

/**
 * Nevyřízen
 */
var NEVYRIZEN = exports.NEVYRIZEN = 'NEVYRIZEN';

/**
 * Vyřízen
 */
var VYRIZEN = exports.VYRIZEN = 'VYRIZEN';

/**
 * Uzavřen
 */
var UZAVREN = exports.UZAVREN = 'UZAVREN';

/**
 * Předán do spisovny
 */
var PREDAN_DO_SPISOVNY = exports.PREDAN_DO_SPISOVNY = 'PREDAN_DO_SPISOVNY';

/**
 * Předán do archivu nebo skartován
 */
var PREDAN_DO_ARCHIVU_NEBO_SKARTOVAN = exports.PREDAN_DO_ARCHIVU_NEBO_SKARTOVAN = 'PREDAN_DO_ARCHIVU_NEBO_SKARTOVAN';

/**
 * Stornován
 */
var STORNOVAN = exports.STORNOVAN = 'STORNOVAN';

/**
 * Skartován
 */
var SKARTOVAN = exports.SKARTOVAN = 'SKARTOVAN';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [NEVYRIZEN, VYRIZEN, UZAVREN, PREDAN_DO_SPISOVNY, PREDAN_DO_ARCHIVU_NEBO_SKARTOVAN, STORNOVAN, SKARTOVAN];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, NEVYRIZEN, { caption: 'Nevyřízen' }), (0, _defineProperty3.default)(_params, VYRIZEN, { caption: 'Vyřízen' }), (0, _defineProperty3.default)(_params, UZAVREN, { caption: 'Uzavřen' }), (0, _defineProperty3.default)(_params, PREDAN_DO_SPISOVNY, { caption: 'Předán do spisovny' }), (0, _defineProperty3.default)(_params, PREDAN_DO_ARCHIVU_NEBO_SKARTOVAN, { caption: 'Předán do archivu nebo skartován' }), (0, _defineProperty3.default)(_params, STORNOVAN, { caption: 'Stornován' }), (0, _defineProperty3.default)(_params, SKARTOVAN, { caption: 'Skartován' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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